













































import { Component, Prop, Vue } from 'vue-property-decorator'
import { VtAppState} from './vt-app-state'
@Component<VtTabbedApp>({})
export default class VtTabbedApp extends Vue{
  // @Prop({default:112,type:Number}) topAppBarHeight!:number
  @Prop() state!:VtAppState
}
